import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../environments/environment';
import { NsideIdentityService } from '../shared/services/auth/nSideIdentityService';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const identity = inject(NsideIdentityService);

  // Always include credentials (cookies) for identity-v2 calls
  let modifiedReq = req.clone({
    withCredentials: true
  });

  // Add Bearer token for API calls (not identity calls)
  const isApiCall = req.url.startsWith(environment.apiBaseUrl);

  if (isApiCall) {
    const token = identity.getToken();
    if (token) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(modifiedReq);
};
